import { connect } from 'react-redux';
import { redirect } from 'redux-first-router';
import { actions as Pages } from '@pages/names';
import Onboarding from './Onboarding';

export const mapStateToProps = (state) => ({
  userId: state.user?._id || null,
  userEmail: state.user?.email || '',
});

export const mapDispatchToProps = (dispatch) => ({
  onGoToRules: () => dispatch(redirect({ type: Pages.Rules })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);
